import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'sh-navigation',
  templateUrl: './navigation.component.html',
  styleUrl: './navigation.component.scss',
  standalone: false
})
export class NavigationComponent implements OnInit {
  constructor() {}

  ngOnInit(): void {}
}
